import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { GetToolsResponse } from '@frontend/types';

type GetToolsParams = {
  instanceId: string;
  include_disabled: boolean;
};

export function getTools({ instanceId, include_disabled }: GetToolsParams) {
  return Object.assign(
    async () => {
      return http
        .get<GetToolsResponse>(
          `${OPAL_URL}/backend/api/v1/instances/${instanceId}/tools?include_disabled=${include_disabled}`
        )
        .then(resp => {
          if (resp.data) {
            return resp.data;
          }
          return {
            functions: [],
            is_allow_list_available: false,
          };
        });
    },
    { key: ['opal:tools'] as const }
  );
}
type ToggleToolStatusParams = {
  instanceId: string;
  is_disabled: boolean;
  function_id: string;
  user_id: string;
};

type ToggleToolEnabledInPrimaryAgentParams = {
  instanceId: string;
  toolName: string;
  isEnabledInPrimaryAgent: boolean;
};

type RestoreToolsInPrimaryAgentParams = {
  instanceId: string;
};

export function toggleToolStatus({
  instanceId,
  is_disabled,
  function_id,
  user_id,
}: ToggleToolStatusParams) {
  const url = `${OPAL_URL}/tools-mgmt-service/api/tools/organizations/${instanceId}/tools/${function_id}/${is_disabled ? 'enable' : 'disable'}?user_id=${user_id}`;
  return http.post(url, {});
}

export function toggleToolEnabledInPrimaryAgent({
  instanceId,
  toolName,
  isEnabledInPrimaryAgent,
}: ToggleToolEnabledInPrimaryAgentParams) {
  const url = `${OPAL_URL}/backend/api/v1/instances/${instanceId}/primary-agent/tools/${isEnabledInPrimaryAgent ? 'disable' : 'enable'}`;
  return http.post(url, { functions: [{ name: toolName }] });
}

export function restoreToolsInPrimaryAgent({ instanceId }: RestoreToolsInPrimaryAgentParams) {
  const url = `${OPAL_URL}/backend/api/v1/instances/${instanceId}/primary-agent/tools/clear`;
  return http.post(url, {});
}

type BulkToggleToolsParams = {
  instanceId: string;
  functionIds: string[];
  userId: string;
  action: 'enable' | 'disable';
};

export async function bulkToggleTools({
  instanceId,
  functionIds,
  userId,
  action,
}: BulkToggleToolsParams) {
  const promises = functionIds.map(functionId => {
    const url = `${OPAL_URL}/tools-mgmt-service/api/tools/organizations/${instanceId}/tools/${functionId}/${action}?user_id=${userId}`;
    return http.post(url, {});
  });
  return Promise.all(promises);
}

type BulkToggleChatEnabledParams = {
  instanceId: string;
  toolNames: string[];
  action: 'enable' | 'disable';
};

export async function bulkToggleChatEnabled({
  instanceId,
  toolNames,
  action,
}: BulkToggleChatEnabledParams) {
  const url = `${OPAL_URL}/backend/api/v1/instances/${instanceId}/primary-agent/tools/${action}`;
  return http.post(url, {
    functions: toolNames.map(name => ({ name })),
  });
}
